// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon"

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DataTable from "../../examples/Tables/DataTable/serverTable";

// Data
import countryTableData from "./data/countryTableData";
import MDButton from "../../components/MDButton";
import { useNavigate } from "react-router-dom";

const CountryList = () => {
  const { columns, rows, totalRecords, pageIndex, pageSize } = countryTableData();
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="contained"
                bgColor="transperent"
                borderRadius="lg"
                // coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                zIndex="1"
                width="calc(100% - 250px)"
              >
                <MDTypography variant="h5" color="black">
                  Country List
                </MDTypography>

                <MDButton
                size="medium"
                  variant="outlined"
                  color="orange"
                  onClick={() => navigate("/country/add")}
                >
                  <Icon fontSize="small" sx={{ mt: -0.25 }}>
                    add_icon
                  </Icon>
                  &nbsp;
                  Add Country
                </MDButton>
              </MDBox>
              <MDBox pt={3} mt={-12.5}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  // entriesPerPage={true}
                  // showTotalEntries={true}
                  noEndBorder
                  canSearch
                  totalRecords={totalRecords}
                  pageIndex1={pageIndex}
                  pageSize1={pageSize}
                  tableFor="countryList"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default CountryList;
